export const GET_NOTES = 'GET_NOTES';
export const ADD_NOTE = 'ADD_NOTE';
export const UPDATE_NOTE = 'UPDATE_NOTE';
export const REMOVE_NOTE = 'REMOVE_NOTE';

export const ADD_FOLDER = 'ADD_FOLDER';
export const ADD_FILE = 'ADD_FILE';
export const SET_CURRENT_FILE = 'SET_CURRENT_FILE';
export const SET_CURRENT_FOLDER = 'SET_CURRENT_FOLDER';
export const SET_CURRENT_NOTE = 'SET_CURRENT_NOTE';

export const SET_IS_NOTE_ADDING = 'SET_IS_NOTE_ADDING';